module.exports = __webpack_public_path__ + "static/media/PlayIcon.bb32aaba.png";